var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box_category"},[_c('div',{staticClass:"box_head"},[_vm._t("head")],2),_c('div',{staticClass:"box_cont",class:{ none_cont: _vm.isEmptyData }},[_vm._t("cont"),(_vm.isEmptyData)?_vm._t("contEmpty"):_vm._e()],2),_c('div',{staticClass:"group_btn"},[_vm._t("side")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }